import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegelSet } from '../models/RegelSet';
import { RegelsService } from '../services/regels.service';
import { RegelComponent } from './regel.component';

@Component({
  selector: 'app-regel-set-details',
  templateUrl: './regel-set-details.component.html',
  styleUrls: ['./beheer-regels.component.scss']
})
export class RegelSetDetailsComponent implements OnInit {
  @Input() regelsEmpty: boolean = false;
  @ViewChild(RegelComponent) regelComponent: RegelComponent;

  toonWaarschuwingGeenRegels: boolean = false;

  public selectedRegelSet: string;

  activeRegelSet: RegelSet = {
    regelSetId: 0,
    naam: ''
  };

  constructor(
    private regelsSvc: RegelsService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.selectedRegelSet = params.get('regelSetId');
      console.log(this.selectedRegelSet);
    });

    this.regelsSvc.loadRegelSet(this.selectedRegelSet).subscribe((o) => {
      this.activeRegelSet = o;
    });
  }

  aantalUpdated(e) {
    console.log(e);

    this.toonWaarschuwingGeenRegels = e === 0;
  }
}
